import Interactions from './interactions';

export default Interactions;